import React, { Suspense, useCallback, useEffect } from "react"
import Footer from "./components/Footer"
import ParticipatingCompanies from "./components/ParticipatingCompanies"
import { useTrack, useVariation } from "@hackler/react-sdk"
import { Button } from "@material-ui/core"
import { GAEvent } from "../../modules/GoogleAnalytics"
import CtaMessage from "../../components/units/CtaMessage"
import useLoginPopup from "../../hooks/useLoginPopup"
import useLogReferralKey from "../../hooks/useLogReferralKey"
import useTrackReferralKey from "../../hooks/useTrackReferralKey"
import { Locale } from "../../locale"
import Webinar from "./components/Webinar"
import HeroSectionRoute from "./HeroSectionRoute"
import { HackleExperiment, HackleVariation } from "@hackler/react-sdk"
import { AA_TEST_KEY, ADD_DATA_ANALYTICS_DETAIL_PAGE } from "../../abTestKey"

const GlobalCompany = React.lazy(() => import("./components/GlobalCompany"))
const AbTest = React.lazy(() => import("./components/AbTest"))
const DataAnalytics = React.lazy(() => import("./components/dataAnalytics/DataAnalytics"))
const PrevDataAnalytics = React.lazy(() => import("./components/dataAnalytics/PrevDataAnalytics"))
const DataInsight = React.lazy(() => import("./components/DataInsight"))
const FeatureFlag = React.lazy(() => import("./components/FeatureFlag"))
const Funnel = React.lazy(() => import("./components/Funnel"))
const AnomalyDetection = React.lazy(() => import("./components/AnomalyDetection"))
const Integration = React.lazy(() => import("./components/Integration"))
const Pricing = React.lazy(() => import("./components/Pricing"))
const About = React.lazy(() => import("./components/About"))

export default function Home() {
  useLogReferralKey()
  useVariation(AA_TEST_KEY)
  const track = useTrack()
  const { lang } = Locale.getDefault()
  const loginPopup = useLoginPopup()
  const trackReferral = useTrackReferralKey()

  const trackLog = useCallback(() => {
    track({ key: "homepage_home_view" })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  useEffect(trackLog, [trackLog])
  useEffect(trackReferral, [trackReferral])

  return (
    <>
      <HeroSectionRoute />
      <ParticipatingCompanies />
      <Suspense fallback={<div />}>
        <GlobalCompany />
        <AbTest />

        <HackleExperiment experimentKey={ADD_DATA_ANALYTICS_DETAIL_PAGE}>
          <HackleVariation variation={"A"}>
            <PrevDataAnalytics />
            <DataInsight />
          </HackleVariation>
          <HackleVariation variation={"B"}>
            <DataAnalytics />
          </HackleVariation>
        </HackleExperiment>

        <FeatureFlag />
        <Funnel />
        <AnomalyDetection />
        <Integration />
        <Pricing />
        {lang === "ko" && <Webinar />}
        <About
          serviceButtonComponent={({ isMobile, className }) => (
            <Button
              color={"inherit"}
              variant={"contained"}
              fullWidth={isMobile}
              className={className}
              onClick={() => {
                GAEvent({
                  category: "main-6",
                  action: "click",
                  label: "start abtest",
                })
                track({ key: "homepage_home_about_abtest_start_click" })
                loginPopup()
              }}>
              <strong>
                <CtaMessage />
              </strong>
            </Button>
          )}
        />
      </Suspense>
      <Footer />
    </>
  )
}
